module.exports = __webpack_public_path__ + "img/alphaleaf_logo_color.dde69d7c.svg";